import { StyleSheet, ViewStyle } from 'react-native'

import { ThemeProps } from '@common/styles/themeConfig'

// Local layout constants for the receive popup card (radii the theme doesn't express).
export const RECEIVE_RADII = {
  lg: 16,
  pill: 100
} as const

interface Style {
  header: ViewStyle
  closeButton: ViewStyle
  qrBox: ViewStyle
  addressPill: ViewStyle
  networks: ViewStyle
  network: ViewStyle
  networkOverflow: ViewStyle
  seeMore: ViewStyle
}

const getStyles = (theme: ThemeProps) =>
  StyleSheet.create<Style>({
    header: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 28
    },
    closeButton: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: 32,
      height: 32,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.tertiaryBackground as string
    },
    qrBox: {
      backgroundColor: '#FFFFFF',
      borderRadius: RECEIVE_RADII.lg,
      padding: 16,
      alignItems: 'center',
      justifyContent: 'center'
    },
    addressPill: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
      maxWidth: '100%',
      borderRadius: RECEIVE_RADII.pill,
      backgroundColor: theme.quaternaryBackground as string,
      paddingVertical: 8,
      paddingHorizontal: 16
    },
    networks: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8
    },
    // Network chip: logo + name on a pill, same surface as the address pill so it
    // reads correctly on both the dark and light theme.
    network: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      borderRadius: RECEIVE_RADII.pill,
      backgroundColor: theme.quaternaryBackground as string,
      paddingVertical: 4,
      paddingLeft: 4,
      paddingRight: 10
    },
    // "+N" chip capping the list when not every network fits on screen. Same
    // height as a network chip, neutral fill like the Shield screen's ChainStack.
    networkOverflow: {
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 40,
      height: 28,
      borderRadius: RECEIVE_RADII.pill,
      backgroundColor: theme.chainStackOverflowBackground as string,
      paddingHorizontal: 10
    },
    seeMore: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })

export default getStyles
